exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".participant-image[data-v-72974218]{max-width:175px;border-radius:100px}", ""]);

// exports
